import { useSelector } from 'react-redux';
import { useTakeoverExperimentContext } from 'modules/experiments/contexts';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { getTakeoverExperimentData } from 'modules/experiments/ducks/selectors';
import { TestStrategy } from 'modules/experiments/types';
import { StyledWinningCriteriaSectionHeader } from '../styled';
import {
  ReadOnlySettingsWrapper,
  StyledSettingsFieldValue,
  StyledSettingsFormField,
} from './Styled';

export const WinningCriteriaTestDurationSettings = () => {
  const { t } = useExperimentsTranslations();
  const experimentData = useSelector(getTakeoverExperimentData);
  const {
    blastCampaignMetaInfo: { testStrategy, testDurationHours, testDurationMinutes },
  } = useTakeoverExperimentContext();

  return (
    <>
      <StyledWinningCriteriaSectionHeader>
        {t('settings.winningCriteria.header')}
      </StyledWinningCriteriaSectionHeader>
      <ReadOnlySettingsWrapper>
        <StyledSettingsFormField
          labelText={t('settings.winningMetricSettings.winningMetric')}
          isHorizontalLayout
        >
          <StyledSettingsFieldValue>{experimentData.winningCriteria.name}</StyledSettingsFieldValue>
        </StyledSettingsFormField>
        {testStrategy === TestStrategy.SUBSET_USERS && (
          <StyledSettingsFormField
            labelText={t('settings.winningMetricSettings.testDurationLabel')}
            isHorizontalLayout
          >
            <StyledSettingsFieldValue>
              {t('settings.winningMetricSettings.testDuration', {
                hours: testDurationHours,
                minutes: testDurationMinutes,
              })}
            </StyledSettingsFieldValue>
          </StyledSettingsFormField>
        )}
      </ReadOnlySettingsWrapper>
    </>
  );
};
